import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTreasure: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTreasure"><Path d="M22 20H18V12H22V20Z" fill="currentColor"/><Path d="M22 10H18V4C20.2091 4 22 5.79086 22 8V10Z" fill="currentColor"/><Path d="M16 10V4H8V10H11V9H13V10H16Z" fill="currentColor"/><Path d="M11 12V13H13V12H16V20H8V12H11Z" fill="currentColor"/><Path d="M6 4V10H2V8C2 5.79086 3.79086 4 6 4Z" fill="currentColor"/><Path d="M6 12V20H2V12H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTreasure;
